import CsiFormData from "csi/action/FormData";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import { CallMethod } from "csi/xml/CallMethod";
import xml from "csi/xml";
import _ from "lodash";
import Controller from "csi/action/Controller";

const SelectStyleCandidatesController = declare(Controller, {
	/**
	 * @override
	 * Pre-select nodes that correspond to keys already in the key container
	 */
	onFormData(fd: CsiFormData) {
		fd.m_bRequireOne = false;
		const mpv = this.m_cache.getNode(this.m_urlNode);
		const preSelectedStyleCandidates = mpv.StyleCandidates; 
		_.forEach(preSelectedStyleCandidates, (url) => {
			fd.addAggregatedNode(this.m_cache.getNode(url));
		});
		return fd;
	},

	toWriterRequest(fd): CallMethod {
		const call = this.inherited<CallMethod>(arguments);
		const nodesRemoved = _.map(this.getFormData().getRemovedNodes());
		const removes = !_.isEmpty(nodesRemoved) ? _.map(nodesRemoved, xml.nodeGetURL) : null;
		call.addParameter("RemoveURLs", xml.ATTR_REFLIST, removes);
		return call;
	},
});

export = SelectStyleCandidatesController;